/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { useUser } from '../hooks/UNSAFE_useUser';
import { classNames } from '../utils/UNSAFE_classNames';
import { HTMLAttributesSignalExcluded } from '../utils/UNSAFE_attributeUtils';
import { ColorProps } from '../utils/UNSAFE_interpolations/colors';
import { DvtThresholdsColors, getDvtThresholdColor } from '../utils/UNSAFE_dvtCommonUtils';
import { styles } from './themes/MeterBarStyles.css';

type IntrinsicProps = Pick<HTMLAttributesSignalExcluded<HTMLDivElement>, 'class'>;
type ThresholdBarProps = IntrinsicProps & {
  color?: ColorProps['color'] | DvtThresholdsColors;
  length: string;
  orientation: 'horizontal' | 'vertical';
};

export function ThresholdBar({ color, length, orientation, ...otherProps }: ThresholdBarProps) {
  const { direction } = useUser();
  const isHoriz = orientation === 'horizontal';
  const isRtl = direction === 'rtl';

  return (
    <div
      class={classNames([
        styles.thresholdBarBaseStyle,
        isHoriz
          ? isRtl
            ? styles.thresholdBarHorizontalBarTrackSectionRtlStyle
            : styles.thresholdBarHorizontalBarTrackSectionLtrStyle
          : styles.thresholdBarVerticalBarTrackSectionStyle,
        otherProps.class
      ])}
      style={{
        width: isHoriz ? length : '100%',
        height: isHoriz ? '100%' : length,
        backgroundColor: getDvtThresholdColor(color)
      }}></div>
  );
}
